import { CloseOutlineIcon } from '@carboncopyco/icons';
import { InlineLink, InputText } from '@carboncopyco/ui';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

export const WorkspaceManageTagSearch = () => {
  const {
    searchKeyExists,
    createTag,
    list,
    searchKey,
    setSearchKey,
    clear,
    selectAll,
  } = useWorkspaceManageTag();
  return (
    <div className="w-full">
      <InputText
        value={searchKey}
        rightElement={
          searchKey?.length > 0 && (
            <div
              className="text-ds-primary-300"
              onClick={() => setSearchKey('')}
            >
              <CloseOutlineIcon />
            </div>
          )
        }
        size="xl"
        fullWidth
        placeholder="Search or create tag"
        onChange={(event) => setSearchKey(event?.target?.value)}
        onKeyPress={({ key }) => {
          if (key === 'Escape') {
            setSearchKey('');
          }
          if (searchKeyExists) {
            return;
          }
          if (key === 'Enter') {
            createTag();
          }
        }}
      />
      {list.length > 0 && (
        <div className="flex justify-between items-center w-full mt-1.5 border-b p-2">
          <InlineLink
            label="Select All"
            className="mb-0.5 cursor-pointer"
            onClick={selectAll}
          />

          <InlineLink
            underline={false}
            label="Clear"
            className="mb-0.5 cursor-pointer text-ds-primary-300"
            onClick={clear}
          />
        </div>
      )}
    </div>
  );
};
